import request from '@/router/axios'; // =====================参数===========================

export var historyFlowList = function historyFlowList(processInstanceId) {
  return request({
    url: '/api/blade-flow/process/history-flow-list',
    method: 'get',
    params: {
      processInstanceId: processInstanceId
    }
  });
}; // =====================请假流程===========================

export var leaveProcess = function leaveProcess(data) {
  return request({
    url: '/api/blade-desk/process/leave/start-process',
    method: 'post',
    data: data
  });
};
export var leaveDetail = function leaveDetail(businessId) {
  return request({
    url: '/api/blade-desk/process/leave/detail',
    method: 'get',
    params: {
      businessId: businessId
    }
  });
};